(function(){

    
    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    document.querySelectorAll('p').forEach( e => {
        if (e.innerHTML === '') e.remove();	
    });

  
    if (document.getElementById("ot-sdk-btn") && document.getElementById("secondary-navigation")) {
        document.getElementById("secondary-navigation").appendChild(document.getElementById("ot-sdk-btn"))
    }


}());